/*
  Smooth open/close animation for <details>/<summary> accordions.
  - Works for FAQ, dropdowns, PDP collapsibles, sidebars, etc.
  - Uses Web Animations API; falls back to native toggle when reduced-motion is enabled.
*/

(function () {
  const prefersReducedMotion =
    typeof window !== 'undefined' &&
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const DURATION = 220;
  const EASING = 'cubic-bezier(0.2, 0.8, 0.2, 1)';

  function wrapDetailsContent(detailsEl) {
    if (!detailsEl || detailsEl.dataset.twDetailsMotion === '1') return null;
    const summary = detailsEl.querySelector(':scope > summary');
    if (!summary) return null;

    const wrapper = document.createElement('div');
    wrapper.className = 'tw-details__content';

    while (summary.nextSibling) {
      wrapper.appendChild(summary.nextSibling);
    }
    detailsEl.appendChild(wrapper);
    detailsEl.dataset.twDetailsMotion = '1';
    return { summary, wrapper };
  }

  function setWrapperHeightAuto(wrapper) {
    wrapper.style.height = '';
    wrapper.style.overflow = '';
  }

  function animateOpen(detailsEl, wrapper) {
    wrapper.style.overflow = 'hidden';
    wrapper.style.height = '0px';
    // Ensure open so content is measurable/layouted.
    detailsEl.open = true;

    const targetHeight = wrapper.scrollHeight;
    const anim = wrapper.animate(
      [{ height: '0px', opacity: 0.85 }, { height: `${targetHeight}px`, opacity: 1 }],
      { duration: DURATION, easing: EASING }
    );
    anim.onfinish = () => setWrapperHeightAuto(wrapper);
  }

  function animateClose(detailsEl, wrapper) {
    wrapper.style.overflow = 'hidden';
    const startHeight = wrapper.getBoundingClientRect().height;

    const anim = wrapper.animate(
      [{ height: `${startHeight}px`, opacity: 1 }, { height: '0px', opacity: 0.85 }],
      { duration: DURATION, easing: EASING }
    );

    anim.onfinish = () => {
      detailsEl.open = false;
      setWrapperHeightAuto(wrapper);
    };
  }

  function enhanceDetails(detailsEl) {
    const res = wrapDetailsContent(detailsEl);
    if (!res) return;
    const { summary, wrapper } = res;

    // If it starts closed, keep wrapper collapsed until first open.
    if (!detailsEl.open) {
      wrapper.style.height = '0px';
      wrapper.style.overflow = 'hidden';
    }

    summary.addEventListener('click', (e) => {
      // Let native behavior happen when reduced motion is preferred.
      if (prefersReducedMotion) return;

      // Prevent native toggle; we’ll manage open/close + animation.
      e.preventDefault();

      // Cancel any running animations to avoid stuck states.
      wrapper.getAnimations().forEach((a) => a.cancel());

      if (detailsEl.open) {
        animateClose(detailsEl, wrapper);
      } else {
        animateOpen(detailsEl, wrapper);
      }
    });
  }

  function init(root) {
    const scope = root || document;
    scope.querySelectorAll('details').forEach((d) => enhanceDetails(d));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  // Shopify Theme Editor: re-init on section load.
  document.addEventListener('shopify:section:load', (e) => {
    const section = e && e.target ? e.target : null;
    init(section || document);
  });
})();

